import PropTypes from "prop-types";
export default {
  /**
   * The ID of the menu that should currently be open, or null.
   */
  currentOpenPanel: PropTypes.string
};